"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _auth = require("../../packages/auth");
var _AxiosRequestConfigWithAuth = require("./AxiosRequestConfigWithAuth");
const AUTH_ERROR_MESSAGE = "Missing ID token: No authentication token was found.";
const createAuthInterceptor = function () {
  return async function (config) {
    try {
      if (!(0, _AxiosRequestConfigWithAuth.isAxiosRequestConfigWithAuth)(config)) return config;
      if (!config.includeAuth) return config;
      const auth = (0, _auth.getAuthToken)();
      if (!auth) throw new Error(AUTH_ERROR_MESSAGE);
      config.headers.Authorization = auth;
      return config;
    } catch (err) {
      return Promise.reject(err);
    }
  };
};
var _default = exports.default = createAuthInterceptor;